import { Fragment, useEffect, useState } from "react";
import { formatCurrency } from "src/utils/FormatCurrency";
import { CategoryAmount, TransactionSummaryDetailModel } from "src/models/TransactionSummaryDetailModel";
import { TransactionTypeCount } from "src/models/TransactionTypeCount";

type TransactionSummaryDataProps = {
  summaryDetail: TransactionSummaryDetailModel;  
};

const TransactionSummaryData = ({
  summaryDetail,
}: TransactionSummaryDataProps) => {  
  const [summaryData, setSummaryData] = useState<TransactionSummaryDetailModel>({} as TransactionSummaryDetailModel);

  useEffect(() => {
    if (summaryDetail) {
      setSummaryData(summaryDetail)
    }
  }, [summaryDetail]);

  return (    
      <div className="">
        <div className="row">          
          <div className="col-6 summary-data">            
            {summaryData?.categoryAmounts?.map(
              (c: CategoryAmount, idx: number) => (
                <Fragment key={`categoryAmounts-${idx}`}>
                  <div className="grouping1">
                    <div>{c.category}</div>
                    <div>
                      {formatCurrency(c.amount,c.alphaCode)}
                    </div>
                  </div>                  
                </Fragment>
              )
            )}
            </div>
            <div className="col-6 summary-data">
            {summaryData?.transactionTypeCounts?.map(
              (t: TransactionTypeCount, idx: number) => (
                <Fragment key={`tranactionTypes-${idx}`}>
                  <div className="grouping" key={`${t.description}-${idx}`}>
                    <div key={`${t.description}-${idx}-label`}>{t.description}</div>
                    <div key={`${t.description}-${idx}-desc`}>
                      {t.count}
                    </div>
                  </div>
                </Fragment>
              )
            )}
          </div>
        </div>
      </div>    
  );
};

export default TransactionSummaryData;
